import { routesMap } from '../model/routesMap';
export function mapRoutePath(path, enabled) {
    if (!enabled) {
        return path;
    }
    if (Array.isArray(path)) {
        return path.map(mapSingle);
    }
    return mapSingle(path);
}
function mapSingle(path) {
    let result = path;
    routesMap.forEach((to, from) => {
        const escaped = escapeRegExp(from);
        const pattern = new RegExp(`(^|/)${escaped}(?=/|$|[?#])`, 'g');
        result = result.replace(pattern, `$1${to}`);
    });
    return result;
}
function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
